import { render, staticRenderFns } from "./LoyaltyOption.vue?vue&type=template&id=57b983d4"
import script from "./LoyaltyOption.vue?vue&type=script&lang=ts"
export * from "./LoyaltyOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports